
import { defineComponent } from "vue";

export default defineComponent({
  name: "custom-example",
  components: {
   
  },
  data(){
    return{
      policyActivationPC: 'https://images.empoweredconsumerism-static-files.com/ovi/advisory/policy_activation_24hrs_PC.jpg',
      over65YrsOldPC: 'https://images.empoweredconsumerism-static-files.com/ovi/advisory/over_65_years_old_PC.jpg',
      readYourInsurancePC: 'https://images.empoweredconsumerism-static-files.com/ovi/advisory/read_your_insurance_policy_PC.jpg',
      repatcarePolicySigningPC: 'https://images.empoweredconsumerism-static-files.com/ovi/advisory/repatcare_policy_signing_PC.jpg',

      policyActivationMobile: 'https://images.empoweredconsumerism-static-files.com/ovi/advisory/policy_activation_24hrs_MOBILE.jpg',
      over65YrsOldMobile: 'https://images.empoweredconsumerism-static-files.com/ovi/advisory/over_65_years_old_MOBILE.jpg',
      readYourInsuranceMobile: 'https://images.empoweredconsumerism-static-files.com/ovi/advisory/read_your_insurance_policy_MOBILE.jpg',
      repatcarePolicySigningMobile: 'https://images.empoweredconsumerism-static-files.com/ovi/advisory/repatcare_policy_signing_MOBILE.jpg',

      windowWidth: window.innerWidth,
      isMobile : false

    }
  },
  methods : {
    onResize() {
      //this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      if(this.windowWidth <= 450){
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }

      console.log("this.windowWidth: " + this.windowWidth);
      console.log("this.isMobile: " + this.isMobile);
    }
  },
  mounted(){
    
    this.windowWidth = window.innerWidth;
    if(this.windowWidth <= 450){
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
/*
    this.$nextTick(() => {
          window.addEventListener('resize', this.onResize);
        });
        */
  }
});
